import HttpFactory from '../factory'
import type { ContactPoint, Owner } from '../types/contact-point'

class ContactPointsModule extends HttpFactory<any[]> {
  private RESOURCE_V2 = '/v2/contact-points'

  async getV2(owner: Owner): Promise<ContactPoint[]> {
    const result = await this.call<any>('GET', `${this.RESOURCE_V2}?&ownerType=${owner.type}&ownerId=${owner.id}`)
    return result.items
  }

  async getSharedV2(usedBy: Owner): Promise<ContactPoint[]> {
    const result = await this.call<any>('GET', `${this.RESOURCE_V2}?&usedByType=${usedBy.type}&usedById=${usedBy.id}`)
    return result.items
  }

  async getContactPointByIdV2(id: string) {
    return await this.call<any>('GET', `${this.RESOURCE_V2}/${id}`)
  }

  async saveV2(obj: Partial<ContactPoint>): Promise<ContactPoint> {
    if (obj.id) {
      return this.call<any>('PATCH', `${this.RESOURCE_V2}/${obj.id}?revision=${obj.revision}`, {
        system: obj.system,
        use: obj.use,
        value: obj.value,
      })
    } else {
      return this.call<any>('POST', `${this.RESOURCE_V2}`, obj)
    }
  }

  async shareV2(obj: Partial<any>): Promise<any> {
    return this.call<any>('POST', `${this.RESOURCE_V2}/${obj.id}/sharings`, {
      id: obj.personId,
      type: obj.type,
    })
  }

  async deleteSharedContactPointById(obj: Partial<any>): Promise<ContactPoint> {
    return this.call<any>(
      'DELETE',
      `${this.RESOURCE_V2}/${obj.id}/sharings?sharedWithType=${obj.sharedWithType}&sharedWithId=${obj.sharedWithId}`,
    )
  }

  async requestVerificationCode(id: string): Promise<ContactPoint> {
    return this.call<any>('POST', `${this.RESOURCE_V2}/${id}/verification`)
  }

  async unVerify(id: string, revisionId: string): Promise<ContactPoint> {
    return this.call<any>('PATCH', `${this.RESOURCE_V2}/${id}?revision=${revisionId}`, {
      verified: false,
    })
  }

  async verificationStatus(id: string, revisionId: string): Promise<ContactPoint> {
    return this.call<any>('PATCH', `${this.RESOURCE_V2}/${id}/verification?revision=${revisionId}`, {
      status: 'verified',
    })
  }

  async deleteContactPointById(id: string, revisionId: string): Promise<ContactPoint> {
    return this.call<any>('DELETE', `${this.RESOURCE_V2}/${id}?revision=${revisionId}`)
  }
}

export default ContactPointsModule
